import { createSelector } from 'reselect';

const moduleSelector = state => state.transactions;

export const getTransactions = createSelector(moduleSelector, state => state.transactions);
export const getTransactionsLoading = createSelector(moduleSelector, state => state.transactionsLoading);
export const getTransactionsError = createSelector(moduleSelector, state => state.transactionsError);
